<template>
    <div>
        <card-header title="Registration Fees" icon="fa-usd-square"></card-header>

        <card-toolbar>
            <button @click="$openCard('rmc-new-fee', {confId: conference.id}, card)"><i class="far fa-plus"></i>New Registration Fee</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <rmc-fee-tile
                    :card="card"
                    :fee="fee"
                    v-for="fee in conference.fees"
                    @click="$openCard('rmc-edit-fee', {confId: fee.conference_id, feeId: fee.id}, card)"
                    :active="(child && child.definition.component === 'rmc-edit-fee' && fee.id === parseInt(child.props.feeId))"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import RmcFeeTile from "../../../components/rmc/RmcFeeTile";

    import {client as http} from '@/http_client';

    export default {
        components: {RmcFeeTile, CardToolbar, CardList, CardHeader, CardBody},
        props: ['card', 'props', 'child'],
        data() {
            return {
                conference: {}
            };
        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('rmc/conferences/' + this.props.confId, {force}).then(response => {
                    this.conference = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            reload: function() {
                this.loadConference(true);
            }
        },
        mounted() {
            this.loadConference();
        }
    }
</script>

<style>

</style>
